"use client";

import { useState } from "react";
import BFLModal from "@repo/shared-ui/BFLModal";
import useModalCloseOnBrowserButton from "@repo/shared-ui/useModalCloseOnBrowserButton";
import { handleInfoIconDL, handleCloseBtnDL } from "./StockFinancialsFunction";
import { selectLoginStatus, useAppSelector } from "@repo/web-store";

const sectionTitle = "Financials";

const StockFinancialsModal = ({ content }: { content: string }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const loginStatus = useAppSelector(selectLoginStatus);

  const handleOpen = () => {
    handleInfoIconDL(loginStatus, sectionTitle);
    setIsModalOpen(true);
  };

  const handleClose = () => {
    handleCloseBtnDL(loginStatus, sectionTitle, "GOT IT", true);
    setIsModalOpen(false);
  };

  useModalCloseOnBrowserButton(isModalOpen, handleClose);

  return (
    <div className="m-3.5 mt-8 md:mt-6">
      <button
        className="text-link-primary cursor-pointer text-base"
        onClick={handleOpen}
      >
        <i className="icomoon before:content-['\e907']" />
      </button>
      <BFLModal
        isOpen={isModalOpen}
        onClose={handleClose}
        buttonText="GOT IT"
        title={sectionTitle}
      >
        <div
          className="text-gray-700"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </BFLModal>
      <div
        className="invisible absolute -left-[9999px] -top-[9999px] h-px w-px overflow-hidden opacity-0"
        aria-hidden="true"
      >
        <div
          className="stock-financials-modal-content"
          data-modal-title={sectionTitle}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
};

export default StockFinancialsModal;
